module.exports = __webpack_public_path__ + "img/album21_29.e7bb1292.jpg";